import React from 'react';
import PropTypes from 'prop-types';
import { SingleSelect } from '@els/els-react--select';
import ExportModalContentTooltip from './ExportModalContentTooltip';

function ExportModalContentFormats({ data, formData, setFormat }) {
  const { format } = formData;
  // override values to be different as labels on UI
  const uiFormats = data?.formats?.map((f) => ({ ...f, value: f.label }));
  const onFormatSelect = ({ value }) => {
    const index = data?.formats?.findIndex((f) => f.label === value);
    setFormat(index);
  };

  return (
    <div className="exportModal__content_row exportModal__content-formats-row">
      <div className="exportModal__content_row_label">Choose a format:</div>
      <div className="exportModal__content_row_value">
        <SingleSelect
          id="exportModal-content-formats-dropdown"
          className="e2e-exportModal-content-formats-dropdown"
          options={uiFormats}
          selectedOptions={format.placeholder ? [format.placeholder] : undefined}
          label="Choose a format"
          required
          onSelect={onFormatSelect}
          size="small"
          shouldHideLabel
        />
      </div>
      <div className="exportModal__content_row_tooltip">
        <ExportModalContentTooltip header="Choose a format" text={data.formatsTooltip} />
      </div>
    </div>
  );
}

function areEqual(prevProps, nextProps) {
  const prevPlaceholder = prevProps.formData?.format?.placeholder;
  const nextPlaceholder = nextProps.formData?.format?.placeholder;
  const prevLength = prevProps.data?.formats?.length;
  const nextLength = nextProps.data?.formats?.length;
  return prevPlaceholder === nextPlaceholder && prevLength === nextLength;
}

ExportModalContentFormats.propTypes = {
  data: PropTypes.object,
  formData: PropTypes.object,
  setFormat: PropTypes.func.isRequired,
};

export default React.memo(ExportModalContentFormats, areEqual);
